import axios from "axios";
import { API_BASE_URL } from "../../../config";

export const getJobDetails = async (quoteId) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/jobs/quote/getJobData`, {
            params: {
                quoteId,
            },
        });
        return response.data;
    } catch (error)
    {
        console.error("Error fetching Job Deatils:", error);
        throw error;
    }
};
